import { makeRequest } from 'utils/requestLogger';

export default (comment) => {
  return makeRequest(
    'post',
    `/api/recaps/${comment.recap_id}/comments`,
    comment
  );
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/postRecapComment.js